import $ from "jquery";
import "./summaryButton.scss";
import { state } from "../../../core/settings";
import { summaryPageComponent } from "../summary-page/summaryPage";
import { CreateImageList, toggleLoad } from "../../../core/3d-configurator";
import { createPDF } from "../../../core/customFunctions/createPDF";

export function summaryButtonComponent(container) {
  const summaryButton = $(`
        <button class="summary__button" id="summary">
            Summary
        </button>`);

  summaryButton.on("click", async () => {
    const mainContent = $("#content");
    const summaryPage = $("#summary-content");

    if ($("#summary-content").length) {
      $("#summary-content").remove();
    }

    $("body").addClass("body-overflow-auto");

    toggleLoad(true);
    summaryPageComponent(mainContent);
    await CreateImageList();
    toggleLoad(false);
  });

  $(container).append(summaryButton);
}
